import { useAllhomesApi } from '@domain-group/fe-co-allhomes-api-client';
var useAuthQueryParams = () => {
  var _useAllhomesApi = useAllhomesApi(),
    isSignedIn = _useAllhomesApi.isSignedIn;
  var context = {
    includeAuth: true
  };
  return {
    queryParams: {
      skip: !isSignedIn,
      ssr: false,
      context
    },
    mutationParams: {
      context
    },
    lazyQueryParams: {
      ssr: false,
      context
    }
  };
};
export default useAuthQueryParams;